import main from './img/Home/main.png'
import circle from './img/Home/circle.png'

export const images = [
    main, circle
];